import { useDispatch, useSelector } from "react-redux";
import { printDisputeThunk } from "../thunks/printDisputeThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { DisputeData } from "../types";
import { setDownloadFetchState } from "../disputeDataSlice";

export const useDisputePrinter = (dispute?: DisputeData) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.clearing.disputes.downloadReportFetchState
	);
	const dispatch = useDispatch();

	const download = React.useCallback(() => {
			dispatch(printDisputeThunk(dispute));
	}, [dispatch,dispute]);

	const dispatchSetFetch = React.useCallback(() => {                   //  Ovo da prvo izađe customDialog box
		dispatch(setDownloadFetchState({ type: "started" }))
	},	[dispatch] );
	
	return [download, fetchState, dispatchSetFetch] as [typeof download, typeof fetchState, typeof dispatchSetFetch];
};
